import React from 'react'
import Prime from '../C_Topics/assets/Prime.png'
const Primes = () => {
    return (
        <div className='container'>
            <h1>What is a Prime Number?</h1>
            <p>A number that's only divisible by 1 and itself is named a Prime Number. For Example, 3, 5, 7, 11 are Prime Numbers.</p>
            <p><strong>Note:</strong> 2 is the only even prime number.</p>
            <h3>Flowchart for Prime Number:</h3>
            <br /> <br />
            <img src={Prime} alt="" />
            <h3>Pseudocode</h3>
            <br /> <br />
           <p> <strong>Step 1:</strong>  Start</p> <br />
<p><strong>Step 2:</strong>  Initialize variables num,flag=1, j=2</p>  <br />
<p><strong>Step 3:</strong> Read num from user</p> <br />
<p><strong>Step 4: </strong> If num&lt;=1 </p>      <br />      // Any number less than 1 is not a prime number
            Display "num is not a prime number"<br />
            Goto step 7<br />
            <p>Step 5: Repeat the steps until j&lt;[(n/2)+1]  <br />
           <strong> 5.1 </strong>If remainder of number divide j equals to 0, <br />
                    Set flag=0 <br />
                    Goto step 6<br />
           <strong> 5.2 </strong>j=j+1 </p> <br />
            <p>Step 6: If flag==0,<br />
            Display num+" is not prime number" <br />
        Else <br />
            Display num+" n is prime number"<br />
           <strong> Step 7:</strong> Stop </p> <br />
     </div>
    )
}

export default Primes
